import { createAction } from 'Lib/reduxUtils';

import {
  HANDLE_LOGIN_ROUTE,
  ROUTE_NAVIGATE,
  SET_ROUTE_END,
  SET_ROUTE_INFO,
  VERIFY_AGE_VERIFICATION_DEEPLINK_ROUTE,
  VERIFY_CAMPAIGN_DEEPLINK_ROUTE,
  VERIFY_CONFIRMATION_DEEPLINK_ROUTE,
  VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE,
  VERIFY_EMAIL_SUBSCRIPTION_TOKEN_ROUTE,
  VERIFY_EXPLORE_ROUTE,
  VERIFY_GOLD_DEEPLINK_ROUTE,
  VERIFY_GOLD_ROUTE,
  VERIFY_INCENTIVES_DEEPLINK_ROUTE,
  VERIFY_MERCHANDISING_ROUTE,
  VERIFY_MESSAGES_ROUTE,
  VERIFY_MUTUAL_FRIENDS_ROUTE,
  VERIFY_NAVIGATE_ROUTE,
  VERIFY_PLUS_ROUTE,
  VERIFY_PREFERENCES_ROUTE,
  VERIFY_PROMO_ROUTE,
  VERIFY_REMOTE_VIEW_ROUTE,
  VERIFY_SETTINGS_ROUTE,
  VERIFY_WEB_PROFILE_ROUTE,
} from './constants';

export const setRouteInfo = createAction(
  SET_ROUTE_INFO,
  (
    path: string,
    params: Record<string, any> = {},
    location: Record<string, any> = __CLIENT__ ? window.location : {}
  ) => ({
    path,
    params,
    location,
  })
);

export const setRouteEnd = createAction(SET_ROUTE_END);

export const handleLoginRoute = createAction(HANDLE_LOGIN_ROUTE);

export const verifyRemoteViewRoute = createAction(
  VERIFY_REMOTE_VIEW_ROUTE,
  ({ type, otp }: { type: string; otp: string }) => ({ type, otp })
);

export const verifyConfirmationDeeplinkRoute = createAction(
  VERIFY_CONFIRMATION_DEEPLINK_ROUTE,
  ({ type, otp }: { type: string; otp: string }) => ({ type, otp })
);

export const verifyEmailRemovalDeeplinkRoute = createAction(
  VERIFY_EMAIL_REMOVAL_DEEPLINK_ROUTE,
  ({ otp }: { otp: string }) => ({ otp })
);

export const verifySettingsRoute = createAction(VERIFY_SETTINGS_ROUTE);

export const verifyMessagesRoute = createAction(VERIFY_MESSAGES_ROUTE, (matchId: string) => ({
  matchId,
}));

export const verifyPlusRoute = createAction(VERIFY_PLUS_ROUTE);

export const verifyPreferencesRoute = createAction(VERIFY_PREFERENCES_ROUTE);

export const verifyMerchandisingRoute = createAction(VERIFY_MERCHANDISING_ROUTE);

export const verifyGoldRoute = createAction(VERIFY_GOLD_ROUTE);

export const verifyGoldDeeplinkRoute = createAction(VERIFY_GOLD_DEEPLINK_ROUTE);

export const verifyCampaignDeeplinkRoute = createAction(
  VERIFY_CAMPAIGN_DEEPLINK_ROUTE,
  ({ otp, campaignInfo }: { otp: string; campaignInfo: string }) => ({ otp, campaignInfo })
);

export const verifyAgeVerificationDeeplinkRoute = createAction(
  VERIFY_AGE_VERIFICATION_DEEPLINK_ROUTE,
  ({ status }: { status: string }) => ({ status })
);
export const verifyEmailSubscriptionTokenRoute = createAction(
  VERIFY_EMAIL_SUBSCRIPTION_TOKEN_ROUTE
);

export const verifyIncentivesDeeplinkRoute = createAction(
  VERIFY_INCENTIVES_DEEPLINK_ROUTE,
  ({ promoCode }: { promoCode: string }) => ({ promoCode })
);

export const verifyPromoRoute = createAction(VERIFY_PROMO_ROUTE);

export const verifyNavigateRoute = createAction(
  VERIFY_NAVIGATE_ROUTE,
  ({ route }: { route: string }) => ({ route })
);

export const verifyWebProfileRoute = createAction(
  VERIFY_WEB_PROFILE_ROUTE,
  ({ username }: { username: string }) => ({ username })
);

export const navigate = createAction(ROUTE_NAVIGATE, (path: string, state?: any) => ({
  path,
  state,
}));

export const verifyExploreRoute = createAction(VERIFY_EXPLORE_ROUTE);

export const verifyMutualFriendsRoute = createAction(VERIFY_MUTUAL_FRIENDS_ROUTE);
